var render, staticRenderFns
import script from "./KDragContainer.vue?vue&type=script&lang=js&"
export * from "./KDragContainer.vue?vue&type=script&lang=js&"
import style0 from "./KDragContainer.vue?vue&type=style&index=0&id=ed258c78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed258c78",
  null
  
)

component.options.__file = "KDragContainer.vue"
export default component.exports